'use client';
import React, { useState } from 'react';
import s from './Collapsable.module.scss';

interface CollapsableProps {
  title: string;
  children: React.ReactNode;
}

const Collapsable: React.FC<CollapsableProps> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCollapse = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button
        type="button"
        className={[s.button, isOpen ? s.active : ''].join(' ')}
        onClick={handleCollapse}
        data-testid={`collapsable-${title}`}
      >
        {title}
      </button>
      {isOpen && <section className={s.content}>{children}</section>}
    </>
  );
};

export default Collapsable;
